import axios from 'axios';
import { setupCache } from 'axios-cache-interceptor';

const instance = axios.create();
const axiosCacheInterceptor = setupCache(instance);

export default axiosCacheInterceptor;
